import { createFileRoute, redirect } from '@tanstack/react-router'

// Integrations has no overview of its own: the sidebar lists every integration and the guide is where one starts.
// The bare section path opens the guide; the search and hash carry over.
export const Route = createFileRoute('/_app/account/integrations/')({
  beforeLoad: ({ location }) => {
    const url = new URL(location.publicHref, 'http://x')
    throw redirect({ href: `/account/integrations/guide${url.search}${url.hash}`, replace: true })
  },
})
